import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Icon, Checkbox } from 'antd'

@inject((store: any) => {
    const { popupStore, couponTypesStore, servicesStore } = store
    return { popupStore, couponTypesStore, servicesStore }
})
@observer
export default class ServicesList extends Component<any, any> {
    selectAllSubs = () => {
        const {
            servicesStore: { list },
            couponTypesStore: { changeEditValue }
        } = this.props
        let joinedServices = []
        list.forEach(service => joinedServices.push(service.id))
        changeEditValue('services', `[${joinedServices.join(',')}]`)
    }
    render() {
        const {
            servicesStore: { list: serviceList },
            couponTypesStore: {
                changeEditValue,
                editCouponType: { services, iteration_charge }
            }
        } = this.props
        const servicesArray = services
            ? services
                  .replace('[', '')
                  .replace(']', '')
                  .trim()
                  .split(',')
            : []
        return (
            <div style={{ backgroundColor: '#f0f2f5', padding: '1rem' }}>
                <h5>
                    <small>בחירת שירותים (נבחרו - {servicesArray.length})</small>
                </h5>
                <div style={{ marginBottom: '1rem' }}>
                    <a style={{ marginLeft: '1rem' }} onClick={() => this.selectAllSubs()}>
                        <Icon type="check-square" /> <span style={{ textDecoration: 'underline' }}>בחר הכל</span>
                    </a>
                    <a onClick={() => changeEditValue('services', null)}>
                        <Icon type="close-square" /> <span style={{ textDecoration: 'underline' }}>נקה הכל</span>
                    </a>
                </div>
                <div style={{ maxHeight: '25vh', overflowX: 'hidden', overflowY: 'auto' }}>
                    {serviceList.map(serviceItem => {
                        const checked = servicesArray.filter(service => +service === +serviceItem.id).length
                        return (
                            (!iteration_charge || serviceItem.iteration_type === 'MONTHLY') && (
                                <Checkbox
                                    checked={checked}
                                    onChange={e => {
                                        let value
                                        if (e.target.checked) {
                                            value = `[${[...servicesArray, serviceItem.id].join(',')}]`
                                        } else {
                                            value =
                                                servicesArray.length > 1
                                                    ? `[${servicesArray.filter(
                                                          service => +serviceItem.id !== +service
                                                      )}]`
                                                    : null
                                        }
                                        changeEditValue('services', value)
                                    }}
                                    key={serviceItem.id}
                                    style={{
                                        width: '100%',
                                        padding: '0.3rem 0',
                                        borderBottom: '1px solid #dedede'
                                    }}
                                >
                                    {serviceItem.name}
                                </Checkbox>
                            )
                        )
                    })}
                </div>
            </div>
        )
    }
}
